const configs = {
  cnpj: '',
  primary_color: '',
  secundary_color: '',
  third_color: '',
  title: '',
  favicon_url: '',
  logo: '',
  logoUrl: '',
  logoAuth: '',
  button_auth_text_color: '',
  menu_text_color: '',
  subtitle_text_color: '',
  login_icons: '',
  email: ''
}

export default {
  initialSystemSettings: { ...configs },
  systemSettings: { ...configs }
}



// WEBPACK FOOTER //
// ./src/features/settings/store/state.js